/**
 * Portal Manta · TIPO_OBRA_MAP
 * Extraído de App.jsx v29.3 (via AST)
 */
import { V } from '../globals.js';

const TIPO_OBRA_MAP = [
  {cod:'A1',  nome:'Duplicações',         un_qtd:'km', cor:V.or,    grupo:'amplia'},
  {cod:'A2',  nome:'Marginais',           un_qtd:'km', cor:'#A0826D', grupo:'amplia'},
  {cod:'A3',  nome:'Interseções',         un_qtd:'un', cor:V.bl,    grupo:'amplia'},
  {cod:'A4',  nome:'Acostamentos',        un_qtd:'km', cor:'#8B7355', grupo:'amplia'},
  {cod:'A5',  nome:'Faixas Adicionais',   un_qtd:'km', cor:'#CD853F', grupo:'amplia'},
  {cod:'A6',  nome:'Correção Traçado',    un_qtd:'vb', cor:V.g4,    grupo:'amplia'},
  {cod:'A7',  nome:'Ciclovias',           un_qtd:'km', cor:V.gn,    grupo:'amplia'},
  {cod:'A9',  nome:'OAE',                 un_qtd:'un', cor:'#5D3A1A', grupo:'oae'},
  {cod:'A10', nome:'Passarelas',          un_qtd:'un', cor:'#8B4A2D', grupo:'oae'},
  {cod:'A11', nome:'Área Escape/Acesso',  un_qtd:'vb', cor:'#C45A2B', grupo:'amplia'},
];

export { TIPO_OBRA_MAP };
export default TIPO_OBRA_MAP;
